import React from "react";
import Helmet from "react-helmet";
import "./About.css";

const About = () => {
  return(
    <div className="about">
      <Helmet title="About Fit My Kid" />

      <div className="story">
        <h1>The Back Story</h1>
        <p>We created <i>Fit My Kid</i> to help eliminate the pain of figuring out what clothing sizes and car seats fit a child across multiple brands.</p>
        <p>Just enter your childs height and weight and we&rsquo;ll show you the appropriate sizes.</p>

        <img src={process.env.PUBLIC_URL + "/img/about-family.jpg"} className="family-photo pull-left" alt="Our family"/>
        <p>After the birth of our second son, we got lots of second hand items and quickly remembered how time consuming it was dealing with them. We hated sorting through them and, on top of that, our boys are ginormous <i>(our youngest was wearing 9 months clothing at 5 months)</i>.</p>
        <p>Figuring out what size they wore in one brand was fine, but the same size in another brand never fit them the same way.</p>

        <p><b className="exclamation">Why is there no consistency across brands?</b></p>

        <p>One weekend, a friend gave us a box of hand-me-down clothes.  It sat in our son’s room for weeks.  When we finally worked up the chutzpah to sort, we found multiple brands and had no idea what size would fit him <i>(cue black and white infomercial frustration)</i>.</p>

        <p>That experience is what prompted us to create Fit My Kid</p>
      </div>

      <div className="docs">
        <h1>A quick overview:</h1>

        <div className="help-group">
          <h2>Setting Height &amp; Weight</h2>
          <p>There are two ways to adjust the height and weight:</p>
          <ul>
            <li>Move the sliders</li>
            <li>Click <i>(or tap)</i> on the number and enter the value manually</li>
          </ul>
        </div>

        <div className="help-group">
          <h2>Amazon Links</h2>
          <p>The Amazon links beside each size are affiliate links that will take you to an Amazon search, filtered to the specific car seat or clothing brand and size combination.</p>
          <p>If you choose to use the links to purchase something from Amazon, we earn a commission on the purchase. The commission comes at no additional charge to you and helps us cover the cost of keeping the site going.</p>
        </div>

        <div className="help-group">
          <h2>Settings</h2>
          <p>Brands can be turned off in settings to hide them from the home page searches</p>
          <p>Selecting a gender in settings will update the Amazon links to attempt to search for gender specific clothing</p>
        </div>
      </div>
    </div>
  );
};

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About/About.js
 **/